<template>
	<v-dialog v-model="dialog" persistent max-width="600" scrollable>
		<v-card>
			<v-card-title class="justify-space-between pb-0">
				<div class="font-size-14 font-weight-bold cl-secondary">Info Stockist</div>
				<v-btn small text class="px-0 mr-n4" @click="modalHide">
					<v-icon color="red">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text v-if="stockist">
				<div class="py-5">
					<v-row class="">
						<v-col sm="12" md="5" xl="4">
							<v-card outlined class="pa-4">
								<v-img
									width="100%"
									:src="(stockist.stockist_image) ? stockist.stockist_image : '/assets/image/no-image-post.png'"
								></v-img>
							</v-card>
						</v-col>
						<v-col sm="12" md="7" xl="8">
							<div class="d-flex flex-column">
								<h2 class="primary--text text-capitalize mb-5">{{ stockist.stockist_name }}</h2>
								<span class="d-flex flex-column align-start mb-2 font-size-10">
									<span>Kode Mitra</span>
									<span class="font-weight-bold">{{ stockist.stockist_code }}</span>
								</span>
								<span class="d-flex flex-column align-start mb-2 font-size-10">
									<span>Nama Mitra</span>
									<span class="font-weight-bold">{{ stockist.stockist_member_name }}</span>
								</span>
								<span class="d-flex flex-column align-start mb-2 font-size-10">
									<span>Email</span>
									<span class="font-weight-bold">{{ stockist.stockist_email }}</span>
								</span>
								<span class="d-flex flex-column align-start mb-5 font-size-10">
									<span>Nomor HP</span>
									<span class="font-weight-bold">{{ stockist.stockist_mobilephone }}</span>
								</span>

								<span class="d-flex flex-column align-start mb-2 font-size-10">
									<span>Alamat</span>
									<span class="font-weight-bold">{{ stockist.stockist_address }}</span>
								</span>
								<span class="d-flex flex-column align-start mb-2 font-size-10">
									<span>Kota</span>
									<span class="font-weight-bold">{{ stockist.stockist_city_name }}</span>
								</span>
								<span class="d-flex flex-column align-start mb-2 font-size-10" v-if="stockist.stockist_province_name">
									<span>Provinsi</span>
									<span class="font-weight-bold">{{ stockist.stockist_province_name }}</span>
								</span>
								
							</div>
						</v-col>
					</v-row>

					<v-row>
						<v-col sm="12" md="12" xl="12">
							<div class="d-block mb-4 font-size-14 font-weight-bold cl-secondary">Lokasi Stockist</div>
							<template v-if="stockist.stockist_latitude && stockist.stockist_longitude">
								<div class="d-block" style="height: 400px">
									<iframe :src="'https://maps.google.com/maps?q=' + stockist.stockist_latitude + ',' + stockist.stockist_longitude +'&z=15&output=embed'" width="100%" height="400" frameborder="0" style="border:0"></iframe>
								</div>
							</template>
							<template v-else>
								<div class="d-flex flex-column fill-height align-center justify-center pa-5 w-100 grey lighten-3" style="height: 300px">
									<v-icon color="grey" large>mdi-information-outline</v-icon>
									<div class="font-size-10 mt-4 text-center cl-grey">Lokasi Stockist tidak dapat ditampilkan.</div>
								</div>
							</template>
						</v-col>
					</v-row>
				</div>
			</v-card-text>
			<v-card-actions class="justify-center">
				<v-col cols="3">
					<v-btn depressed block color="primary" class="white--text rounded-lg text-capitalize" @click="modalHide">
						<v-icon small v-if="false">mdi-close</v-icon>
						<span>Tutup</span>
					</v-btn>
				</v-col>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: ['stockist'],
	data () {
		return {
			dialog: false,
		}
	},
	computed: {
	},
	methods: {
		modalShow() {
			this.dialog = true
		},
		modalHide() {
			this.dialog = false
		},
	}
};
</script>